import IncomingInvitationHeader from "./SubComponents/IncomingInvitationHeader";
import {VisitorIncomingInvitationApp} from "./Functionality/VisitorIncomingInvitationApp";
import IncomingInvitationBody from "./SubComponents/IncomingInvitationBody";

/**
 * @Email : azapata@ibl.mx
 * @Author: Ferro Zapata Arnulfo
 * @jobTittle: Full Stack Developer
 *
 */
const VisitorIncomingInvitation = () => {

    const {
        isOnline,
        setIsReload,
        item,
        handleChange,
        t,
        withSearchPendingToComplete,
        withSearchPendingValidation,
        withSearchReadyToEnter,
        withSearchCheckIn,
        search,
        setSearch
    } = VisitorIncomingInvitationApp();

    return (
        <>
            <IncomingInvitationHeader
                isOnline={isOnline}
                setIsReload={setIsReload}
                item={item}
                handleChange={handleChange}
                search={search}
                setSearch={setSearch}
            />
            <IncomingInvitationBody
                t={t}
                withSearchPendingToComplete={withSearchPendingToComplete}
                withSearchPendingValidation={withSearchPendingValidation}
                withSearchReadyToEnter={withSearchReadyToEnter}
                withSearchCheckIn={withSearchCheckIn}
            />
        </>
    );
};

export default VisitorIncomingInvitation;
